exports.dosageForms = [
  {
    key: 'UNIT',
    label: {
      en: 'Unit',
      es: 'Unit',
    },
    unitCategories1: [ 'WEIGHT', 'VOLUME', 'MEQ', 'UNITS' ],
    unitType2: 'UNITS',
  },
  {
    key: 'MDI',
    label: {
      en: 'MDI',
      es: 'MDI',
    },
    unitCategories1: [ 'WEIGHT', 'VOLUME', 'MEQ', 'UNITS' ],
    unitType2: 'PUFFS',
  },
  {
    key: 'TABLET',
    label: {
      en: 'Tablet',
      es: 'Tablet',
    },
    unitCategories1: [ 'WEIGHT', 'VOLUME', 'MEQ', 'UNITS' ],
    unitType2: 'TABLETS',
  },
  {
    key: 'PILL',
    label: {
      en: 'Pill',
      es: 'Pill',
    },
    unitCategories1: [ 'WEIGHT', 'VOLUME', 'MEQ', 'UNITS' ],
    unitType2: 'PILLS',
  },
  {
    key: 'CAPSULE',
    label: {
      en: 'Capsule',
      es: 'Capsule',
    },
    unitCategories1: [ 'WEIGHT', 'VOLUME', 'MEQ', 'UNITS' ],
    unitType2: 'CAPSULES',
  },
  {
    key: 'BOTTLE',
    label: {
      en: 'Bottle',
      es: 'Bottle',
    },
    unitCategories1: [ 'WEIGHT', 'VOLUME', 'MEQ', 'UNITS' ],
    unitType2: 'BOTTLES',
  },
  {
    key: 'DROP',
    label: {
      en: 'Drop',
      es: 'Drop',
    },
    unitCategories1: [ 'WEIGHT', 'VOLUME', 'MEQ', 'UNITS' ],
    unitType2: 'DROPS',
  },
  {
    key: 'INCH',
    label: {
      en: 'Inch',
      es: 'Inch',
    },
    unitCategories1: [ 'WEIGHT', 'VOLUME', 'MEQ', 'UNITS' ],
    unitType2: 'INCHES',
  },
  {
    key: 'SPRAY',
    label: {
      en: 'Spray',
      es: 'Spray',
    },
    unitCategories1: [ 'WEIGHT', 'VOLUME', 'MEQ', 'UNITS' ],
    unitType2: 'SPRAYS',
  },
  {
    key: 'TUBE',
    label: {
      en: 'Tube',
      es: 'Tube',
    },
    unitCategories1: [ 'WEIGHT', 'VOLUME', 'MEQ', 'UNITS' ],
    unitType2: 'TUBES',
  },
  {
    key: 'PACKET',
    label: {
      en: 'Packet',
      es: 'Packet',
    },
    unitCategories1: [ 'WEIGHT', 'VOLUME', 'MEQ', 'UNITS' ],
    unitType2: 'PACKETS',
  },
  {
    key: 'ACTUATION',
    label: {
      en: 'Actuation',
      es: 'Actuation',
    },
    unitCategories1: [ 'WEIGHT', 'VOLUME', 'MEQ', 'UNITS' ],
    unitType2: 'ACTUATION',
  },
  {
    key: 'PATCH',
    label: {
      en: 'Patch',
      es: 'Patch',
    },
    unitCategories1: [ 'WEIGHT', 'VOLUME', 'MEQ', 'UNITS' ],
    unitType2: 'PATCHES',
  },
  {
    key: 'TOPICAL_OINTMENT',
    label: {
      en: 'Topical Ointment',
      es: 'Topical Ointment',
    },
    unitCategories1: [ 'WEIGHT', 'VOLUME', 'MEQ', 'UNITS' ],
    unitType2: 'INCHES',
  },
  {
    key: 'ODT',
    label: {
      en: 'ODT',
      es: 'ODT',
    },
    unitCategories1: [ 'WEIGHT', 'VOLUME', 'MEQ', 'UNITS' ],
    unitType2: 'TABLETS',
  },
  {
    key: 'SUPPOSITORY',
    label: {
      en: 'Suppository',
      es: 'Suppository',
    },
    unitCategories1: [ 'WEIGHT', 'VOLUME', 'MEQ', 'UNITS' ],
    unitType2: 'SUPPOSITORY',
  },
  {
    key: 'BULLET',
    label: {
      en: 'Bullet',
      es: 'Bullet',
    },
    unitCategories1: [ 'WEIGHT', 'VOLUME', 'MEQ', 'UNITS' ],
    unitType2: 'BULLETS',
  },
  {
    key: 'LOZENGE',
    label: {
      en: 'Lozenge',
      es: 'Lozenge',
    },
    unitCategories1: [ 'WEIGHT', 'VOLUME', 'MEQ', 'UNITS' ],
    unitType2: 'LOZENGES',
  },
  {
    key: 'GEL',
    label: {
      en: 'Gel',
      es: 'Gel',
    },
    unitCategories1: [ 'WEIGHT', 'VOLUME', 'MEQ', 'UNITS' ],
    unitType2: 'TUBES',
  },
  {
    key: 'AUTOINJECTOR',
    label: {
      en: 'Autoinjector',
      es: 'Autoinjector',
    },
    unitCategories1: [ 'WEIGHT', 'VOLUME', 'MEQ', 'UNITS' ],
    unitType2: 'AUTOINJECTOR',
  },
  {
    key: 'SOLUTION',
    label: {
      en: 'Solution',
      es: 'Solution',
    },
    unitCategories1: [ 'WEIGHT', 'MEQ', 'UNITS' ],
    unitCategories2: [ 'VOLUME' ],
  },
  {
    key: 'SUSPENSION',
    label: {
      en: 'Suspension',
      es: 'Suspension',
    },
    unitCategories1: [ 'WEIGHT', 'MEQ', 'UNITS' ],
    unitCategories2: [ 'VOLUME' ],
  },
];

exports.unitTypes = [
  { key: 'WEIGHT_G', label: { en: 'g', es: 'g' }, category: 'WEIGHT' },
  { key: 'WEIGHT_MG', label: { en: 'mg', es: 'mg' }, category: 'WEIGHT' },
  { key: 'WEIGHT_MCG', label: { en: 'mcg', es: 'mcg' }, category: 'WEIGHT' },
  { key: 'WEIGHT_NG', label: { en: 'ng', es: 'ng' }, category: 'WEIGHT' },
  { key: 'VOLUME_ML', label: { en: 'mL', es: 'mL' }, category: 'VOLUME' },
  { key: 'VOLUME_CC', label: { en: 'cc', es: 'cc' }, category: 'VOLUME' },
  { key: 'VOLUME_L', label: { en: 'L', es: 'L' }, category: 'VOLUME' },
  { key: 'MEQ', label: { en: 'mEq', es: 'mEq' }, category: 'MEQ' },
  { key: 'UNITS', label: { en: 'unit', es: 'unit' }, category: 'UNITS' },
  { key: 'MUNITS', label: { en: 'mUnit', es: 'mUnit' }, category: 'UNITS' },
  { key: 'PUFFS', label: { en: 'puff', es: 'puff' } },
  { key: 'TABLETS', label: { en: 'tablet', es: 'tablet' } },
  { key: 'PILLS', label: { en: 'pill', es: 'pill' } },
  { key: 'CAPSULES', label: { en: 'capsule', es: 'capsule' } },
  { key: 'BOTTLES', label: { en: 'bottle', es: 'bottle' } },
  { key: 'DROPS', label: { en: 'drop', es: 'drop' } },
  { key: 'INCHES', label: { en: 'inch', es: 'inch' } },
  { key: 'SPRAYS', label: { en: 'spray', es: 'spray' } },
  { key: 'TUBES', label: { en: 'tube', es: 'tube' } },
  { key: 'PACKETS', label: { en: 'packet', es: 'packet' } },
  { key: 'ACTUATION', label: { en: 'actuation', es: 'actuation' } },
  { key: 'SUPPOSITORY', label: { en: 'suppository', es: 'suppository' } },
  { key: 'BULLETS', label: { en: 'bullet', es: 'bullet' } },
  { key: 'LOZENGES', label: { en: 'lozenge', es: 'lozenge' } },
  { key: 'GEL', label: { en: 'gel', es: 'gel' } },
  { key: 'AUTOINJECTOR', label: { en: 'autoinjector', es: 'autoinjector' } },
  { key: 'PATCHES', label: { en: 'patch', es: 'patch' } },
];

exports.medicationGroups = [
  { key: 'ACETAMINOPHEN', label: { en: 'Acetaminophen', es: 'Acetaminophen' }},
  { key: 'ACETAZOLAMIDE', label: { en: 'Acetazolamide', es: 'Acetazolamide' } },
  { key: 'ACTIVATED_CHARCOAL', label: { en: 'Activated Charcoal', es: 'Activated Charcoal' }},
  { key: 'ACYCLOVIR', label: { en: 'Acyclovir', es: 'Acyclovir' } },
  { key: 'ADENOSINE', label: { en: 'Adenosine', es: 'Adenosine' }},
  { key: 'ALBUTEROL', label: { en: 'Albuterol', es: 'Albuterol' }},
  { key: 'ALTEPLASE', label: { en: 'Alteplase', es: 'Alteplase' } },
  { key: 'AMIODARONE', label: { en: 'Amiodarone', es: 'Amiodarone' }},
  { key: 'AMPICILLIN', label: { en: 'Ampicillin', es: 'Ampicillin' } },
  { key: 'ANGIOTENSIN_II', label: { en: 'Angiotensin II', es: 'Angiotensin II' } },
  { key: 'ARGATROBAN', label: { en: 'Argatroban', es: 'Argatroban' } },
  { key: 'ASPIRIN', label: { en: 'Aspirin', es: 'Aspirin' }},
  { key: 'ATROPINE', label: { en: 'Atropine', es: 'Atropine' }},
  { key: 'ATROPINE_PRALIDOXIME', label: { en: 'Atropine/Pralidoxime', es: 'Atropine/Pralidoxime' }},
  { key: 'AZITHROMYCIN', label: { en: 'Azithromycin', es: 'Azithromycin' } },
  { key: 'BUMETANIDE', label: { en: 'Bumetanide', es: 'Bumetanide' } },
  { key: 'CALCIUM_CHLORIDE', label: { en: 'Calcium Chloride', es: 'Calcium Chloride' }},
  { key: 'CALCIUM_GLUCONATE', label: { en: 'Calcium Gluconate', es: 'Calcium Gluconate' }},
  { key: 'CEFAZOLIN', label: { en: 'Cefazolin', es: 'Cefazolin' } },
  { key: 'CEFEPIME', label: { en: 'Cefepime', es: 'Cefepime' } },
  { key: 'CEFTRIAXONE', label: { en: 'Ceftriaxone', es: 'Ceftriaxone' } },
  { key: 'CHLOROTHIAZIDE', label: { en: 'Chlorothiazide', es: 'Chlorothiazide' } },
  { key: 'CIPROFLOXACIN', label: { en: 'Ciprofloxacin', es: 'Ciprofloxacin' } },
  { key: 'CISATRACURIUM', label: { en: 'Cisatracurium', es: 'Cisatracurium' } },
  { key: 'CLEVIDIPINE', label: { en: 'Clevidipine', es: 'Clevidipine' } },
  { key: 'CLINDAMYCIN', label: { en: 'Clindamycin', es: 'Clindamycin' } },
  { key: 'D10_DEXTROSE', label: { en: 'D10/Dextrose 10%', es: 'D10/Dextrose 10%' }},
  { key: 'D25_DEXTROSE', label: { en: 'D25/Dextrose 25%', es: 'D25/Dextrose 25%' }},
  { key: 'D50_DEXTROSE', label: { en: 'D50/Dextrose 50%', es: 'D50/Dextrose 50%' }},
  { key: 'D5_DEXTROSE', label: { en: 'D5/Dextrose 5%', es: 'D5/Dextrose 5%' }},
  { key: 'DEXMEDETOMIDINE', label: { en: 'Dexmedetomidine', es: 'Dexmedetomidine' } },
  { key: 'DEXTROSE', label: { en: 'Dextrose', es: 'Dextrose' }},
  { key: 'DIAZEPAM', label: { en: 'Diazepam', es: 'Diazepam' }},
  { key: 'DIGOXIN', label: { en: 'Digoxin', es: 'Digoxin' }},
  { key: 'DILTIAZEM', label: { en: 'Diltiazem', es: 'Diltiazem' }},
  { key: 'DIPHENHYDRAMINE', label: { en: 'Diphenhydramine', es: 'Diphenhydramine' }},
  { key: 'DIPRIVAN', label: { en: 'Diprivan (Propofol)', es: 'Diprivan (Propofol)' } },
  { key: 'DOBUTAMINE', label: { en: 'Dobutamine', es: 'Dobutamine' } },
  { key: 'DOPAMINE', label: { en: 'Dopamine', es: 'Dopamine' }},
  { key: 'EPINEPHRINE', label: { en: 'Epinephrine', es: 'Epinephrine' }},
  { key: 'EPOPROSTENOL', label: { en: 'Epoprostenol', es: 'Epoprostenol' } },
  { key: 'EPTIFIBATIDE', label: { en: 'Eptifibatide', es: 'Eptifibatide' } },
  { key: 'ESMOLOL', label: { en: 'Esmolol', es: 'Esmolol' } },
  { key: 'ETOMIDATE', label: { en: 'Etomidate', es: 'Etomidate' }},
  { key: 'FAMOTIDINE', label: { en: 'Famotidine', es: 'Famotidine' }},
  { key: 'FENTANYL', label: { en: 'Fentanyl', es: 'Fentanyl' }},
  { key: 'FLUMAZENIL', label: { en: 'Flumazenil', es: 'Flumazenil' }},
  { key: 'FOSPHENYTOIN', label: { en: 'Fosphenytoin', es: 'Fosphenytoin' } },
  { key: 'FUROSEMIDE', label: { en: 'Furosemide', es: 'Furosemide' }},
  { key: 'GENTAMICIN', label: { en: 'Gentamicin', es: 'Gentamicin' } },
  { key: 'GLUCAGON', label: { en: 'Glucagon', es: 'Glucagon' }},
  { key: 'GLUCOSE', label: { en: 'Glucose', es: 'Glucose' }},
  { key: 'HALOPERIDOL', label: { en: 'Haloperidol', es: 'Haloperidol' }},
  { key: 'HEPARIN', label: { en: 'Heparin', es: 'Heparin' }},
  { key: 'HYDRALAZINE', label: { en: 'Hydralazine', es: 'Hydralazine' } },
  { key: 'HYDROMORPHONE', label: { en: 'Hydromorphone', es: 'Hydromorphone' }},
  { key: 'HYPERTONIC_SALINE_23_4', label: { en: 'Hypertonic saline 23.4%', es: 'Hypertonic saline 23.4%' } },
  { key: 'HYPERTONIC_SALINE_3', label: { en: 'Hypertonic saline 3%', es: 'Hypertonic saline 3%' } },
  { key: 'IBUPROFEN', label: { en: 'Ibuprofen', es: 'Ibuprofen' }},
  { key: 'INSULIN', label: { en: 'Insulin', es: 'Insulin' } },
  { key: 'IPRATROPIUM_BROMIDE', label: { en: 'Ipratropium Bromide', es: 'Ipratropium Bromide' }},
  { key: 'KETAMINE', label: { en: 'Ketamine', es: 'Ketamine' }},
  { key: 'KETOROLAC', label: { en: 'Ketorolac', es: 'Ketorolac' }},
  { key: 'LABETALOL', label: { en: 'Labetalol', es: 'Labetalol' }},
  { key: 'LEVALBUTEROL', label: { en: 'Levalbuterol', es: 'Levalbuterol' }},
  { key: 'LEVETIRACETAM', label: { en: 'Levetiracetam', es: 'Levetiracetam' } },
  { key: 'LIDOCAINE', label: { en: 'Lidocaine', es: 'Lidocaine' }},
  { key: 'LISINOPRIL', label: { en: 'Lisinopril', es: 'Lisinopril' }},
  { key: 'LORAZEPAM', label: { en: 'Lorazepam', es: 'Lorazepam' }},
  { key: 'MAGNESIUM_SULFATE', label: { en: 'Magnesium Sulfate', es: 'Magnesium Sulfate' }},
  { key: 'MELOXICAM', label: { en: 'Meloxicam', es: 'Meloxicam' }},
  { key: 'METHYLPREDNISOLONE', label: { en: 'Methylprednisolone', es: 'Methylprednisolone' }},
  { key: 'METOPROLOL', label: { en: 'Metoprolol', es: 'Metoprolol' }},
  { key: 'METRONIDAZOLE', label: { en: 'Metronidazole', es: 'Metronidazole' } },
  { key: 'MIDAZOLAM', label: { en: 'Midazolam', es: 'Midazolam' }},
  { key: 'MILRINONE', label: { en: 'Milrinone', es: 'Milrinone' } },
  { key: 'MORPHINE', label: { en: 'Morphine', es: 'Morphine' }},
  { key: 'MOXIFLOCAXIN', label: { en: 'Moxifloxacin', es: 'Moxifloxacin' }},
  { key: 'NALOXONE', label: { en: 'Naloxone', es: 'Naloxone' }},
  { key: 'NICARDIPINE', label: { en: 'Nicardipine', es: 'Nicardipine' } },
  { key: 'NITROGLYCERIN', label: { en: 'Nitroglycerin', es: 'Nitroglycerin' }},
  { key: 'NITROPRUSSIDE', label: { en: 'Nitroprusside', es: 'Nitroprusside' } },
  { key: 'NOREPINEPHRINE', label: { en: 'Norepinephrine', es: 'Norepinephrine' }},
  { key: 'OCTREOTIDE', label: { en: 'Octreotide', es: 'Octreotide' } },
  { key: 'ONDANSETRON', label: { en: 'Ondansetron', es: 'Ondansetron' }},
  { key: 'OXYMETAZOLINE', label: { en: 'Oxymetazoline', es: 'Oxymetazoline' }},
  { key: 'PANTOPRAZOLE', label: { en: 'Pantoprazole', es: 'Pantoprazole' }},
  { key: 'PHENYLEPHRINE', label: { en: 'Phenylephrine', es: 'Phenylephrine' } },
  { key: 'PHENYTOIN', label: { en: 'Phenytoin', es: 'Phenytoin' } },
  { key: 'PIPERACILLIN_TAZOBACTAM', label: { en: 'Piperacillin Tazobactam', es: 'Piperacillin Tazobactam' } },
  { key: 'PREDNISONE', label: { en: 'Prednisone', es: 'Prednisone' }},
  { key: 'PROCAINAMIDE', label: { en: 'Procainamide', es: 'Procainamide' }},
  { key: 'PROMETHAZINE', label: { en: 'Promethazine', es: 'Promethazine' }},
  { key: 'ROCURONIUM', label: { en: 'Rocuronium', es: 'Rocuronium' }},
  { key: 'SODIUM_BICARBONATE', label: { en: 'Sodium Bicarbonate', es: 'Sodium Bicarbonate' }},
  { key: 'SUCCINYLCHOLINE', label: { en: 'Succinylcholine', es: 'Succinylcholine' }},
  { key: 'THIAMINE', label: { en: 'Thiamine', es: 'Thiamine' }},
  { key: 'TRANEXAMIC_ACID', label: { en: 'Tranexamic Acid', es: 'Tranexamic Acid' }},
  { key: 'VALPROIC_ACID', label: { en: 'Valproic Acid', es: 'Valproic Acid' } },
  { key: 'VANCOMYCIN', label: { en: 'Vancomycin', es: 'Vancomycin' } },
  { key: 'VASOPRESSIN', label: { en: 'Vasopressin', es: 'Vasopressin' }},
  { key: 'VECURONIUM', label: { en: 'Vecuronium', es: 'Vecuronium' }},
  { key: 'VERAPAMIL', label: { en: 'Verapamil', es: 'Verapamil' }},
];

exports.pushTimeFrames = [
  {
    key: 'RAPID',
    label: {
      en: 'Rapid (0 seconds)',
      es: 'Rapid (0 seconds)',
    },
    order: 0
  },
  {
    key: 'FIFTEEN',
    label: {
      en: '00:00:15',
      es: '00:00:15',
    },
    order: 1
  },
  {
    key: 'THIRTY',
    label: {
      en: '00:00:30',
      es: '00:00:30',
    },
    order: 2
  },
  {
    key: 'FOURTY_FIVE',
    label: {
      en: '00:00:45',
      es: '00:00:45',
    },
    order: 3
  },
  {
    key: 'SIXTY',
    label: {
      en: '00:01:00',
      es: '00:01:00',
    },
    order: 4
  },
  {
    key: 'ONE_TWENTY',
    label: {
      en: '00:02:00',
      es: '00:02:00',
    },
    order: 5
  },
  {
    key: 'ONE_EIGHTY',
    label: {
      en: '00:03:00',
      es: '00:03:00',
    },
    order: 6
  },
  {
    key: 'THREE_HUNDRED',
    label: {
      en: '00:05:00',
      es: '00:05:00',
    },
    order: 7
  },
  {
    key: 'SIX_HUNDRED',
    label: {
      en: '00:10:00',
      es: '00:10:00',
    },
    order: 8
  },
];

exports.infusionBagVolumes = [
  {
    key: 'ML_10',
    label: {
      en: '10 mL',
    },
    volumeML: 10,
  },
  {
    key: 'ML_50',
    label: {
      en: '50 mL',
    },
    volumeML: 50,
  },
  {
    key: 'ML_50_GLASS',
    label: {
      en: '50 mL (glass bottle)',
    },
    volumeML: 50,
  },
  {
    key: 'ML_100',
    label: {
      en: '100 mL',
    },
    volumeML: 100,
  },
  {
    key: 'ML_100_GLASS',
    label: {
      en: '100 mL (glass bottle)',
    },
    volumeML: 100,
  },
  {
    key: 'ML_125',
    label: {
      en: '125 mL',
    },
    volumeML: 125,
  },
  {
    key: 'ML_200',
    label: {
      en: '200 mL',
    },
    volumeML: 200,
  },
  {
    key: 'ML_250',
    label: {
      en: '250 mL',
    },
    volumeML: 250,
  },
  {
    key: 'ML_300',
    label: {
      en: '300 mL',
    },
    volumeML: 300,
  },
  {
    key: 'ML_350',
    label: {
      en: '350 mL',
    },
    volumeML: 350,
  },
  {
    key: 'ML_500',
    label: {
      en: '500 mL',
    },
    volumeML: 500,
  },
  {
    key: 'ML_1000',
    label: {
      en: '1000 mL',
    },
    volumeML: 1000,
  },
];

exports.infusionDosingTypes = [
  {key: 'G_KG_HR', label: {en: 'g/kg/hr'}, category: 'WEIGHT', numeratorUnits: 'WEIGHT_G' },
  {key: 'G_HR', label: {en: 'g/hr'}, category: 'WEIGHT', numeratorUnits: 'WEIGHT_G' },
  {key: 'G_MIN', label: {en: 'g/min'}, category: 'WEIGHT', numeratorUnits: 'WEIGHT_G' },
  {key: 'MG_KG_HR', label: {en: 'mg/kg/hr'}, category: 'WEIGHT', numeratorUnits: 'WEIGHT_MG' },
  {key: 'MG_KG_MIN', label: {en: 'mg/kg/min'}, category: 'WEIGHT', numeratorUnits: 'WEIGHT_MG' },
  {key: 'MG_HR', label: {en: 'mg/hr'}, category: 'WEIGHT', numeratorUnits: 'WEIGHT_MG' },
  {key: 'MG_MIN', label: {en: 'mg/min'}, category: 'WEIGHT', numeratorUnits: 'WEIGHT_MG' },
  {key: 'MCG_KG_HR', label: {en: 'mcg/kg/hr'}, category: 'WEIGHT', numeratorUnits: 'WEIGHT_MCG' },
  {key: 'MCG_KG_MIN', label: {en: 'mcg/kg/min'}, category: 'WEIGHT', numeratorUnits: 'WEIGHT_MCG' },
  {key: 'MCG_HR', label: {en: 'mcg/hr'}, category: 'WEIGHT', numeratorUnits: 'WEIGHT_MCG' },
  {key: 'MCG_MIN', label: {en: 'mcg/min'}, category: 'WEIGHT', numeratorUnits: 'WEIGHT_MCG' },
  {key: 'NG_KG_MIN', label: {en: 'ng/kg/min'}, category: 'WEIGHT', numeratorUnits: 'WEIGHT_NG' },
  {key: 'ML_KG_HR', label: {en: 'mL/kg/hr'}, category: 'VOLUME', numeratorUnits: 'VOLUME_ML' },
  {key: 'ML_HR', label: {en: 'mL/hr'}, category: 'VOLUME', numeratorUnits: 'VOLUME_ML' },
  {key: 'ML_MIN', label: {en: 'mL/min'}, category: 'VOLUME', numeratorUnits: 'VOLUME_ML' },
  {key: 'MEQ_KG_HR', label: {en: 'meq/kg/hr'}, category: 'MEQ', numeratorUnits: 'MEQ' },
  {key: 'MEQ_HR', label: {en: 'meq/hr'}, category: 'MEQ', numeratorUnits: 'MEQ' },
  {key: 'UNITS_KG_HR', label: {en: 'units/kg/hr'}, category: 'UNITS', numeratorUnits: 'UNITS' },
  {key: 'UNITS_KG_MIN', label: {en: 'units/kg/min'}, category: 'UNITS', numeratorUnits: 'UNITS' },
  {key: 'UNITS_HR', label: {en: 'units/hr'}, category: 'UNITS', numeratorUnits: 'UNITS' },
  {key: 'UNITS_MIN', label: {en: 'units/min'}, category: 'UNITS', numeratorUnits: 'UNITS' },
  {key: 'MUNITS_KG_MIN', label: {en: 'munits/kg/min'}, category: 'UNITS', numeratorUnits: 'MUNITS' },
  {key: 'MUNITS_MIN', label: {en: 'munits/min'}, category: 'UNITS', numeratorUnits: 'MUNITS' },
];